import {PostRequestRegisterDocumentParams} from 'domain/usecases/others/facial-biometric';
import {makePostRequestFacialBiometricRegisterDocument} from 'main/factories/usecases/others/facial-biometric/request/post-register-document';

export const postRegisterDocument = async (
	params: PostRequestRegisterDocumentParams,
): Promise<void> => {
	const response = await makePostRequestFacialBiometricRegisterDocument().post(params);
	return response;
};
